'use strict';

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['angular'], factory);
  } else if (typeof exports !== "undefined") {
    factory(require('angular'));
  } else {
    var mod = {
      exports: {}
    };
    factory(global.angular);
    global.index = mod.exports;
  }
})(this, function (_angular) {
  var _angular2 = _interopRequireDefault(_angular);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var app = _angular2.default.module('angular-files-drop', []);

  app.directive('filesDrop', ['$q', '$parse', directive]);

  function directive($q, $parse) {
    return {
      restrict: 'A',
      scope: false,
      link: link
    };

    function link($scope, $element, $attrs) {
      readAsDataURL = readAsDataURL.bind({
        $q: $q
      });
      $element.addClass('filesDrop');
      $element[0].addEventListener('dragleave', fileDragleave);
      $element[0].addEventListener('dragover', fileDragover);
      $element[0].addEventListener('drop', fileDrop);
      $scope.$on('$destroy', function () {
        $element[0].removeEventListener('dragleave', fileDragleave);
        $element[0].removeEventListener('dragover', fileDragover);
        $element[0].removeEventListener('drop', fileDrop);
      });

      function fileDrop(event) {
        event.stopPropagation();
        event.preventDefault();
        var dt = event.dataTransfer;
        var files = dt && dt.files || null;

        if (!files) {
          $parse($attrs.filesDrop)($scope, {
            $files: [],
            $event: event
          });
          fileDragleave(event);
          return;
        }

        var promises = [].reduce.call(files, function (prev, file) {
          var promise = readAsDataURL(file).then(function (dataURL) {
            return file.dataURL = dataURL;
          });
          prev.push(promise);
          return prev;
        }, []);
        $q.all(promises).then(function () {
          $parse($attrs.filesDrop)($scope, {
            $files: files,
            $event: event
          });
          fileDragleave(event);
        });
      }

      function fileDragover(event) {
        event.stopPropagation();
        event.preventDefault();
        $element.addClass('filesDrop--dragover');
      }

      function fileDragleave() {
        $element.removeClass('filesDrop--dragover');
      }
    }
  }

  function readAsDataURL(file) {
    return new this.$q(function (done, reject) {
      if (file instanceof File || file instanceof Blob) {
        var reader = new FileReader();

        reader.onloadend = function (loadEvent) {
          return done(loadEvent.target.result);
        };

        reader.readAsDataURL(file);
      } else {
        reject(new Error('Expected image.readAsDataURL(arg1): arg1 to be File instance, but got ' + file));
      }
    });
  }
});